require('./style.less');


var PageImageWr = require('../page'),
    $ = require('jquery'),
    DocModeTextLayer = require('../textLayer/docMode/view');


module.exports = PageImageWr.extend({

    className: 'FV-pgWr FV-pgWr-PgDocMode',

    TEXT_LAYER_VIEW: DocModeTextLayer,

    /**
     * TODO:
     * - should all come from higher level queue function -- handleDocModeImgPrefetch
     * - should be before request image at higher level when using queue
     * Always call from dimUnknown preload ( non FDD images )
     */
    requestImg: function() {

        if ( !this.model.isFddImage() || !this.options.vChannel.request('docModeImagesLoadingExceedsThreshold') ) {
            PageImageWr.prototype.requestImg.apply(this, arguments);
        }

    },
    onRender: function() {

        PageImageWr.prototype.onRender.call(this);

        /* Must come after -- unwrap will be diff $el */
        this.$el.on('inview', _.bind(function() {
            this.model.trigger('creRequest');
        }, this ));

    },

    // Necessary for rotation on text-layer ( rotate is not called explicitly anymore )
    updateViewPort: function() {

        PageImageWr.prototype.updateViewPort.apply( this, arguments );

        // TODO: only if rotation value changed ... can handle here on in child
        this.textLayerView && this.textLayerView.rotate();

    },


    onBeforeImageRequest: function() {
        this.$el.off('inview');
        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: true});
    },
    enterLoadError: function() {
        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: false});
        PageImageWr.prototype.enterLoadError.apply(this, arguments);
    },
    enterImageLoaded: function() {
        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: false});
        PageImageWr.prototype.enterImageLoaded.apply(this, arguments);
    },

    // Part of quick fix before implementation of image queue
    // load others not queued up b/c not yet using queue
    onAfterImgRevealed: function() {
        this.imgView.el !== null && //in case of quick change
            this.options.vChannel.command('checkForDocModeImagesInView');
    },

    onBeforeDestroy: function() {
        this.$el.off('inview');
        PageImageWr.prototype.onBeforeDestroy.apply( this, arguments );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/docMode/pageDocMode.js
 ** module id = 416
 ** module chunks = 0
 **/